module.exports = __webpack_public_path__ + "img/book4.f3c6237d.png";